import "./RoleBadge.css";

/**
 * Returns 'white' or 'black' based on the perceived brightness of a hex color.
 */
const getContrastColor = (hex) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  // Perceived brightness formula (ITU-R BT.709)
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 150 ? "#1a1a1a" : "#ffffff";
};

const RoleBadge = ({ name, color }) => {
  return (
    <span
      className="role-badge"
      style={{
        backgroundColor: color,
        color: getContrastColor(color),
      }}
    >
      {name}
    </span>
  );
};

export default RoleBadge;
